import {useContext, useEffect, useState, useCallback} from 'react';

import InputSelect from '../../../base_components/select/InputSelect';
import Context from '../Context';
import _axios from '../../../utils/axios';
import validate from '../../../utils/validator';
import {handleError} from '../../../utils/utils';

import buttonStyles from '../../../styles/base_components/Button.module.scss';
import styles from '../../../styles/users/ActionsOnGroups.module.scss';

function ActionsOnGroups(props) {
  // InputSelect
  const [placeholder, setPlaceholder] = useState('');
  const [input, setInput] = useState('');
  const [groups, setGroups] = useState({});
  const [error, setError] = useState('');

  const context = useContext(Context);

  const clearGroups = useCallback(() => {
    let g = {};
    for (let groupName in context.groups) {
      g[groupName] = false;
    }
    setGroups(g);
    setPlaceholder('');
  }, [context.groups]);

  function onAdd(event) {
    if (error) return;
    const [groupErr] = validate([
        {value: input, type: 'group_name'}
    ]);
    if (groupErr) {
      setError(groupErr);
      return;
    }

    const data = {
      name: input,
      path: '/' + input
    };
    _axios.post(context.role.GROUPS_PATH, data)
      .then(response => {
        const {ok, data} = response.data;
        if (typeof ok !== 'number' || typeof data !== 'object') throw new Error('The database does not correspond to our standard.');
        if (ok !== 1) throw new Error('The database is currently unavailable.');
        let err = validate([
          {value: data.id, type: 'db_group_id'},
          {value: data.name, type: 'db_group_name'},
          {value: data.path, type: 'db_group_path'}
        ]);
        err = err.filter(e => e !== '');
        if (err.length !== 0) throw new Error('Error at validating ' + data.name + ': ' + err.join('. '));

        context.setGroups(groups => {
          let newGroups = {};
          newGroups[data.name] = {
            id: data.id,
            path: data.path,
            subGroups: []
          };
          return {...newGroups, ...groups};
        });
        setInput('');
      })
      .catch(handleError);
  }

  function onRemove(event) {
    if (error) return;
    const [selectErr] = validate([
      {value: groups, type: 'select'}
    ]);
    if (selectErr) {
      setError(selectErr);
      return;
    }

    // TODO send all selected groups to request
    const selectedGroups = Object.keys(groups).filter(groupName => groups[groupName]);
    const name = selectedGroups[0];
    const id = context.groups[name].id;
    if (name === context.defaultGroup) {
      clearGroups();
      throw new Error('You tried to delete the default group!');
    }

    const config = {
      data: {id: id}
    };
    _axios.delete(context.role.GROUPS_PATH, config)
      .then(response => {
        context.setGroups(groups => {
          let newGroups = {...groups};
          delete newGroups[name];
          return newGroups;
        });
        clearGroups();
      })
      .catch(handleError);
  }

  useEffect(() => {
    clearGroups()
  }, [context.groups, clearGroups]);

  return (
    <div className={styles.actionsOnGroups + ' ' + props.className}>
      <h2>Actions on groups</h2>
      <InputSelect
        className={styles.select}
        input={input}
        setInput={setInput}
        defaultPlaceholder='Enter group name'
        placeholder={placeholder}
        setPlaceholder={setPlaceholder}
        items={groups}
        setItems={setGroups}
        error={error}
        setError={setError}
      />

      <div className={styles.buttons}>
        <button className={buttonStyles.button} onClick={onAdd}>add</button>
        <button className={buttonStyles.button} onClick={onRemove}>remove</button>
      </div>
    </div>
  );
}

export default ActionsOnGroups;